import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { siteInfo } from "../data/content";

const footerLinks = [
  { label: "Programs & Pricing", href: "/#programs" },
  { label: "Find Tutors", href: "/marketplace" },
  { label: "Success Stories", href: "/#success-stories" },
  { label: "Contact Us", href: "/#contact" },
];

export default function Footer() {
  return (
    <footer className="mt-24 overflow-hidden border-t border-white/10 bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800 text-white">
      <div className="section-shell grid gap-10 py-14 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="relative">
          <div className="floating-dot -left-8 top-0 h-28 w-28" />
          <div className="relative z-10 space-y-5">
            <div className="brand-shell">
              <img src={logo} alt="Dreameer Education logo" className="h-12 w-auto sm:h-16" />
            </div>
            <div>
              <p className="font-display text-3xl font-extrabold">Dreameer Education</p>
              <p className="mt-2 max-w-2xl text-sm leading-7 text-white/72">
                Our promise: structured plans, verified tutors, personalised feedback, mock reviews,
                and parent-friendly reporting that actually helps families stay informed.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link to="/#book-demo" className="button-primary">
                Book Demo
              </Link>
              <Link to="/marketplace" className="button-ghost">
                Explore Tutors
              </Link>
            </div>
          </div>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <h3 className="font-display text-xl font-extrabold">Quick Links</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/75">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="transition hover:text-white">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-display text-xl font-extrabold">Contact</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/75">
              <li>WhatsApp: {siteInfo.phone}</li>
              <li>{siteInfo.email}</li>
              <li>Office: {siteInfo.officeHours}</li>
              <li>Trusted tutors | Verified profiles | Structured courses</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="section-shell py-5 text-xs font-semibold uppercase tracking-[0.2em] text-white/45">
          Copyright 2026 Dreameer Education. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
